import ramly from "../../assets/images/ramly.png";
import notepad from "../../assets/images/notepad.png";
import pomo from "../../assets/images/pomo.png";
import tastebudd from "../../assets/images/tastebudd.png";
import tiktalk from "../../assets/images/chat2.png";
import arceus from "../../assets/images/arceus.png";

const project_list = [
  {
    name: "Tastebudds (E-commerce Web)",
    content:
      "A simple e-commerce website. Users are able to register an account, login to it and start shopping! After checking out your shopping cart, you will be able to see your order history on your profile page via the little cute profile button on the navbar ;)",
    stack: "HTML CSS Javascript React Vite TailwindCss Node.js MongoDB",
    link: "https://tastebudds.vercel.app/",
    image: tastebudd,
    github_link: "https://github.com/shaowei0925/tastebudds",
  },
  {
    name: "Arceus (Recipe Reccomendation App)",
    content:
      "A full stack recipe recommendation app that allows user to find the top rated recipe at the same time keeping track his/her daily nutritional intakes.",
    image: arceus,
    link: "https://arceusproject.vercel.app/",
    github_link: "https://github.com/jneoh001/Arceus",
    stack: "HTML CSS JavaScript TailwindCss React Firebase",
  },
  {
    name: "TikTalk (Messaging App)",
    content:
      "A very simple messaging app, so what you can do? Register, Login and start TikTalking!. I am not planning to deploy this because this app is far from PERFECT HAHA.",
    image: tiktalk,
    link: "https://github.com/shaowei0925/chatApp",
    github_link: "https://github.com/shaowei0925/chatApp",
    stack: "HTML CSS JavaScript React Firebase",
  },
];

export default project_list;
